import { assertNever } from '@kofno/piper';
import { just, nothing } from 'maybeasy';
import CountryRegionOptionsStore from '../../../CountryRegionOptionsStore';
import ErrorActionableReaction, { EAProps } from '../../../ErrorActionableReaction';
import FileUploadStore from '../../../FileUploadStore';
import { FileUploadState } from '../../../FileUploadStore/Types';
import ProfileFormStore from '../../../ProfileFormStore';
import { Link } from '../../../Resource/Types';
import { Upload } from '../../../Uploads';

interface Props extends EAProps<FileUploadStore> {
  profileStore: ProfileFormStore;
  countryRegionOptionsStore: CountryRegionOptionsStore;
}

/**
 * The file is already in S3 by the time this runs, so the preview comes from
 * a local object URL and the form carries the blob's signed id. Nothing is
 * sent to the server until the profile form is saved.
 */
const successfulUpload = (upload: Upload, profileStore: ProfileFormStore) => {
  profileStore.setAvatar(
    just<Link>({
      rel: 'avatar',
      href: upload.previewUrl,
      method: 'get',
      type: 'application/json',
    }),
  );
  profileStore.setAvatarSignedIdToSubmit(just(upload.signedId));
};

const removeUpload = (profileStore: ProfileFormStore) => {
  profileStore.setAvatar(nothing());
  profileStore.setAvatarSignedIdToSubmit(just(''));
};

class PhotoUploadReactions extends ErrorActionableReaction<
  FileUploadStore,
  FileUploadState,
  Props
> {
  tester = () => this.props.store.state;

  effect = (state: FileUploadState): void => {
    const { profileStore } = this.props;

    switch (state.kind) {
      case 'upload-successful':
        successfulUpload(state.upload, profileStore);
        break;
      case 'removing':
        removeUpload(profileStore);
        break;
      case 'waiting':
      case 'ready':
      case 'error':
      case 'upload-in-progress':
        break;
      default:
        assertNever(state);
    }
  };
}

export default PhotoUploadReactions;
